import { Clock10, NotebookPen, UsersRound } from 'lucide-react';
import { Card, CardDescription, CardHeader, CardTitle } from '@shared/ui';
import EFL_DUMBBELL_BENCH from '@shared/assets/pictures/lp-pic-one.png';

interface ServiceProps {
  title: string;
  description: string;
  icon: JSX.Element;
}

const serviceList: ServiceProps[] = [
  {
    title: '24/7 Access',
    description: `Our gym is open around the clock, so you can work out whenever it fits your schedule. Enjoy the convenience and flexibility of a gym that’s always available.`,
    icon: <Clock10 width={45} />,
  },
  {
    title: 'Personalized Training',
    description: `Receive expert guidance from our certified trainers who tailor workout plans to meet your individual goals and fitness levels. Achieve your best results with customized support.`,
    icon: <NotebookPen width={50} />,
  },
  {
    title: 'Group Classes',
    description: `Join our group classes and enjoy a fun, supportive environment while getting fit.`,
    icon: <UsersRound width={30} />,
  },
];

export const Services = () => {
  return (
    <section className="container py-24 sm:py-32" id="services">
      <div className="grid place-items-center gap-8 lg:grid-cols-[1fr,1fr]">
        <div>
          <h2 className="text-3xl font-bold md:text-4xl">
            <span className="bg-gradient-to-b from-primary/60 to-primary bg-clip-text text-transparent">
              Member{' '}
            </span>
            Services
          </h2>

          <div className="mt-4 flex flex-col gap-8">
            {serviceList.map(({ icon, title, description }: ServiceProps) => (
              <Card key={title}>
                <CardHeader className="flex items-start justify-start gap-4 space-y-1 md:flex-row">
                  <div className="p-1">{icon}</div>
                  <div>
                    <CardTitle>{title}</CardTitle>
                    <CardDescription className="text-md mt-2">
                      {description}
                    </CardDescription>
                  </div>
                </CardHeader>
              </Card>
            ))}
          </div>
        </div>
        <img src={EFL_DUMBBELL_BENCH} />
      </div>
    </section>
  );
};
